module.exports = __webpack_public_path__ + "assets/0b81ecc0f0bd689f46bb950025321197.png";